module.exports = __webpack_public_path__ + "static/media/CBRD-LOGO.ba3bf1ad.png";